// extracted by mini-css-extract-plugin
export var productImage = "_mz-1";
export var viewLink = "_mz-2";
export var wishlistItem = "_mz-0";